import { t } from 'i18next'
import React from 'react'

export const postalText = (text) => t(`postal.${text}`)

const PostalTypesSection = ({ postalTypes }) => {
   return (
      <div className="bg-white p-2 rounded-lg">
         <h2 className="text-xl font-medium mb-4">{postalText('Postal_Types')}</h2>

         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {postalTypes && postalTypes.length > 0 ? (
               postalTypes.map((type) => (
                  <div
                     key={type.id}
                     className="bg-gray-50 p-4 rounded-md border border-gray-200 shadow-sm"
                  >
                     <div className="flex items-center mb-3">
                        {type.logo && (
                           <div className="mr-3 flex-shrink-0">
                              <img
                                 src={type.logo}
                                 alt={type.name}
                                 className="h-10 w-auto object-contain"
                              />
                           </div>
                        )}
                        <h3 className="font-medium text-lg">{type.name}</h3>
                     </div>
                     {type.title && type.title !== type.name && (
                        <p className="text-gray-700 font-medium text-sm mb-1">{type.title}</p>
                     )}
                     <p className="text-gray-600 mt-1 text-sm">{type.description || 'No description available'}</p>
                     <div className="flex justify-between items-center mt-3 pt-2 border-t border-gray-200">
                        <span className="text-xs text-gray-500">ID: {type.id}</span>
                        {type.status !== undefined && (
                           <span className={`px-2 py-1 rounded-full text-xs ${type.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                              {type.status ? 'Active' : 'Inactive'}
                           </span>
                        )}
                     </div>
                  </div>
               ))
            ) : (
               <div className="col-span-full text-center py-8 text-gray-500">
                  No postal types available.
               </div>
            )}
         </div>
      </div>
   )
}

export default PostalTypesSection